import { useSelector } from 'react-redux';

/**
 * A wrapper around useSelector that allows us to use the
 * VanSiteRootState type.
 * @template T
 * @param {(state: import('../../../types/vansite').VanSite.State.Application) => T} selector - The selector function
 * @param {(a: T, b: T) => boolean} [equalityFn] - The equality function to use
 * @returns {T} - The selected state
 */
const useAppSelector = (selector, equalityFn = (a, b) => a === b) => {
  return useSelector(selector, equalityFn);
};

export default useAppSelector;
